import { bindable, customElement } from 'aurelia';
import template from './location-map-modal.html';
import type { Collection } from '../services/api.types';
import { getCollectionLocationMapUrl } from '../services/api.service';

@customElement({ name: 'location-map-modal', template })
export class LocationMapModal {
  @bindable public collection!: Collection;
  @bindable public closed!: () => void;

  private _keyHandler!: (e: KeyboardEvent) => void;

  public get imageUrl(): string {
    return getCollectionLocationMapUrl(this.collection.id, this.collection.locationMapGeneratedAt ?? undefined);
  }

  public attached(): void {
    this._keyHandler = (e: KeyboardEvent) => { if (e.key === 'Escape') this.close(); };
    document.addEventListener('keydown', this._keyHandler);
  }

  public detached(): void {
    document.removeEventListener('keydown', this._keyHandler);
  }

  public close(): void { this.closed(); }
}
